module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento12.4175a3cc.svg";